<template>
    <GroupSingleText
        :field-id="fieldId"
        :key="fieldId"
        :field-namespace="fieldNamespace"
    />
</template>

<script>
import store from '@/store/store';
import GroupSingleText from '@/views/Public/Field/Fields/Groups/GroupSingleText';

export default {
    components: { GroupSingleText },
    props: {
        fieldId: {
            type: String,
            required: true
        },

        fieldNamespace: {
            type: String,
            required: true
        }
    },

    computed: {
        groupFieldType() {
            return store.state[this.fieldNamespace].options.groupFieldType;
        },

        name() {
            return store.state[this.fieldNamespace].name;
        },
    }
};
</script>
